import { render, staticRenderFns } from "./dirView.vue?vue&type=template&id=cd624bd8&"
import script from "./dirView.vue?vue&type=script&lang=js&"
export * from "./dirView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports